import { Typography } from "@material-ui/core";
import { LynxLink } from "components/LynxLink/LynxLink";
import React from "react";
import { CopyrightProps } from "./CopyrightProps";
import { copyrightStyles } from "./CopyrightStyles";

export function Copyright({ className }: CopyrightProps) {
    const classes = copyrightStyles();

    return (
        <div className={className}>
            <Typography variant="subtitle2" className={classes.firstLine}>
                By Continuing You Agree To Our{" "}
                <LynxLink href="#" className={classes.link}>
                    Terms Of Service
                </LynxLink>
            </Typography>
            <Typography variant="subtitle2" className={classes.secondLine}>
                &copy;{new Date().getFullYear()} All Rights Reserved.
                Carrier&reg;
            </Typography>
        </div>
    );
}
